import { createSlice } from '@reduxjs/toolkit';
import initialState from './reportInitialState';
import { _setReportForm } from './reportActions';

const reportSlice = createSlice({
  name: 'stop/reportDetail',
  initialState,
  reducers: {
    getReportDetail: (state, action) => action.payload,
    setReportForm: _setReportForm,
    resetReportDetail: () => initialState,
  },
});

export const { getReportDetail, setReportForm, resetReportDetail } =
  reportSlice.actions;
export default reportSlice.reducer;
